import { Injectable } from '@angular/core';
import { LabRequisition } from '../models/labRequisition.model';
import { HttpClient } from '@angular/common/http';
import { GridService } from '../shared/grid/grid.service';

@Injectable({
  providedIn: 'root'
})
export class LabRequisitionService extends GridService<LabRequisition> {

  constructor(http: HttpClient) {
    super('LabRequisition', http);
  }
}
